import { Swiper } from 'swiper';
import { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-swiper]');

    this.swiperOptions = {
      modules: [A11y, Autoplay, Navigation, Pagination, Scrollbar],
      threshold: 10,
    };

    // Check if we have extra options on the HTML
    if (this.swiperElement.dataset && this.swiperElement.dataset.options) {
      const jsonOptions = JSON.parse(this.swiperElement.dataset.options);

      if (jsonOptions) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...jsonOptions,
        };
      }
    }

    this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

    // Only do it once, not on every web component render.
    window.onload = () => this.init();
  }

  init() {
    if (!this.dataset?.url) return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommended-products]').innerHTML;

        this.querySelector('[data-recommended-products]').innerHTML = html;
        //find all .skeleton and animate them to opacity-0
        const skeleton = this.querySelectorAll('.skeleton');
        const productCard = this.querySelectorAll('.product-card');

        productCard.forEach((element) => element.classList.add('!opacity-0'));

        // wait for 50ms to fade in all product-card
        setTimeout(() => {
          skeleton.forEach((element) => element.classList.add('!opacity-0'));
          productCard.forEach((element) => element.classList.add('!opacity-100'));
        }, 50);

        setTimeout(() => skeleton.forEach((element) => element.remove()), 600);

        this.swiperInstance.update();
        this.swiperInstance.navigation?.init();
        this.swiperInstance.navigation?.update();
        this.swiperInstance.pagination?.init();
        this.swiperInstance.pagination?.update();
        this.swiperInstance.scrollbar?.init();
        this.swiperInstance.scrollbar?.updateSize();
      })
      .catch((error) => console.error(error));
  }
}

customElements.define('product-recommendations', ProductRecommendations);
